import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHero from "@/components/PageHero";
import { Container, ShoreBadge, EmptyState } from "@/components/shared";
import { CalendarClock } from "lucide-react";

export default function TwentyThirty() {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data));
  }, []);

  return (
    <div>
      <PageHero
        kicker="The 400th year"
        title="The 2030 ledger"
        intro="On 7 September 1630 the daughter city took the mother town's name. 2030 marks four hundred years. This is a running record of gatherings on both shores — kept by a private citizen, open to all."
        dark
      />

      <section className="py-16 sm:py-24">
        <Container>
          {events.length === 0 ? (
            <EmptyState icon={<CalendarClock size={22} />} heading="The ledger is still being written" text="Entries for the 400th year will be recorded here as they are confirmed on both shores." />
          ) : (
            <div className="max-w-4xl mx-auto">
              {events.map((e, i) => (
                <div key={e.id} data-testid={`event-${i}`} className="grid sm:grid-cols-12 gap-6 py-8 border-b border-[#D6D3CB] first:pt-0">
                  <div className="sm:col-span-3">
                    <p className="font-playfair italic text-lg text-[#CDA434]">
                      {new Date(e.date).toLocaleDateString("en-GB", { day: "numeric", month: "long" })}
                    </p>
                    <p className="font-sans text-sm text-[#505A68]">{new Date(e.date).getFullYear()}</p>
                  </div>
                  <div className="sm:col-span-9">
                    <div className="mb-2"><ShoreBadge shore={e.shore} /></div>
                    <h3 className="font-serif text-xl text-[#1E1E2F] mb-1">{e.title}</h3>
                    <p className="font-sans text-xs uppercase tracking-wide text-[#505A68] mb-3">{e.place}</p>
                    <p className="font-sans text-base text-[#1B2430] leading-relaxed">{e.summary}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </Container>
      </section>
    </div>
  );
}
